import { render, staticRenderFns } from "./technicalScoreSummary.vue?vue&type=template&id=a1bd5504&scoped=true"
import script from "./technicalScoreSummary.vue?vue&type=script&lang=js"
export * from "./technicalScoreSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1bd5504",
  null
  
)

export default component.exports